import ProtectedRoute from '@efex-components/protectedRoutes/ProtectedRoutes';
import mixpanelSvc from '@efex-services/mixpanel/mixpanelSvc';
import { Grid } from '@mui/material';
import { selectProfileData } from '@pages/profile/store/selectors';
import { t } from 'i18next';
import { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import useEffectOnce from '@main-hooks/useEffectOnce';
import AuthInitializer from '@/modules/auth/AuthInitializer';
import SideBar from './components/SideBar';
import { USA_FORM_STEPS } from './constants';
import { FormProvider } from './context';
import OnboardingForm from './steps';
import HeaderActions from '@/components/common/HeaderActions/HeaderActions';

const UsaOnboarding = () => {
  const userProfile = useSelector(selectProfileData);
  const { isKyc } = userProfile || {};
  const [formStep, setFormStep] = useState(0);
  const [completed, setCompleted] = useState<{
    [k: number]: boolean;
  }>({});

  const countryOrigin = useMemo(
    () => userProfile?.company.country,
    [userProfile?.company.country]
  );

  const sendMixpanelEvent = () => {
    mixpanelSvc.track('Onboarding step', {
      step: formStep + 1,
      userType: 'COMPANY',
    });
  };

  const stepsCompany = useMemo(
    () => [
      t('onbCompanyDocumentation'),
      t('onbBankInformation'),
      t('onbTransactionalProfile'),
      t('onbStakeHolders'),
    ],
    []
  );

  const handleComplete = () => {
    const newCompleted = completed;
    newCompleted[formStep] = true;
    setCompleted(newCompleted);
    sendMixpanelEvent();
  };

  useEffectOnce(() => {
    sendMixpanelEvent();
  });

  useEffect(() => {
    if (!isKyc) return;

    setCompleted({
      [USA_FORM_STEPS.COMPANY_DOCUMENTATION]: true,
      [USA_FORM_STEPS.BANK_INFORMATION]: true,
      [USA_FORM_STEPS.IDENTIFICATION_OFFICIAL]: true,
    });

    setFormStep(USA_FORM_STEPS.ONBOARDING_CONFIRMATION);
  }, [isKyc]);

  return (
    <ProtectedRoute>
      <AuthInitializer>
        <Grid
          container
          spacing={2}
          sx={{ flexWrap: 'wrap-reverse' }}
          className="min-h-screen"
        >
          <Grid item xs={12} md={3}>
            <HeaderActions />
            <SideBar
              currentStep={formStep}
              steps={stepsCompany}
              isKyc={isKyc}
              setFormStep={setFormStep}
            />
          </Grid>

          <Grid item xs={12} md={9}>
            <FormProvider>
              <OnboardingForm
                countryOrigin={countryOrigin}
                formStep={
                  isKyc ? USA_FORM_STEPS.ONBOARDING_CONFIRMATION : formStep
                }
                isDisabledEdit={false}
                uploadCompleted={handleComplete}
                setFormStep={setFormStep}
              />
            </FormProvider>
          </Grid>
        </Grid>
      </AuthInitializer>
    </ProtectedRoute>
  );
};

export default UsaOnboarding;
